import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { withRouter } from 'react-router-dom';

import withProfile from 'hocs/withProfile';

import { MODERATOR, JORNALIST, BILLER, EDITOR, CORRECTOR, SUPERVISOR } from 'utils/roles';

import Gradient from 'admin-editor/components/Gradient';
import Mascot from 'admin-editor/components/Mascot';
import ReactionSelect from 'admin-editor/components/ReactionSelect';
import SnoozesAutocomplete from 'admin-editor/containers/SnoozesAutocomplete';
import DeletePublication from 'admin-editor/containers/DeletePublication';

import RightColumnBody from 'styled/Page/RightColumnBody';

import Checkbox from 'components/Checkbox';
import Select from 'components/Select';

import Input from 'styled/Input';
import Label from 'styled/Label';
import Tab from 'styled/Tab';
import PrimaryButton from 'styled/Buttons/PrimaryButton';

const CHECKBOX_PARAMS = [
  {
    label: 'Запинить публикацию',
    value: 'isPinned',
  }, {
    label: 'Пуш-уведомление',
    value: 'isPush',
  }, {
    label: '18+',
    value: 'isAdult',
  }, {
    label: 'Только для авторизованных',
    value: 'isAuthorizedOnly',
  }, {
    label: 'Информационный шум',
    value: 'isNoise',
  }, {
    label: 'Партнерский материал',
    value: 'isPartner',
  },
];

const TABS = [
  {
    label: 'Везде',
    value: 'everywhere',
  }, {
    label: 'В приложение',
    value: 'application',
  }, {
    label: 'На сайт',
    value: 'web',
  },
];

 export class PublicationParams extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleTypeChange = this.props.onInputChange.bind(this, 'postType');
    this.handleAuthorChange = this.props.onInputChange.bind(this, 'author');
    this.handleDateChange = this.props.onInputChange.bind(this, 'publishedAt');
    this.handleSourceLinkChange = this.props.onInputChange.bind(this, 'sourceLink');
    this.handleMascotPhraseChange = this.props.onInputChange.bind(this, 'mascotPhrase');
    this.handleMascotTypeChange = this.props.onInputChange.bind(this, 'mascotType');

    this.handlePositiveReactionChange = this.props.onFieldChange.bind(this, 'positiveReaction');
    this.handleNegativeReactionChange = this.props.onFieldChange.bind(this, 'negativeReaction');
    this.handleSnoozesChange = this.props.onFieldChange.bind(this, 'snoozes');
    this.handleMascotActivate = this.props.onFieldChange.bind(this, 'isMascotActive', true);
    this.handleMascotDeactivate = this.props.onFieldChange.bind(this, 'isMascotActive', false);

    this.handleProcessClick = this.props.onStateChange.bind(this, 'processing');
    this.handlePublishClick = this.props.onStateChange.bind(this, 'published');
    this.handleHideClick = this.props.onStateChange.bind(this, 'hidden');
  }

  render() {
    return (
      <Scrollbars
        autoHide
        autoHeight
        autoHeightMax="calc(100vh - 50px)"
      >
        <RightColumnBody>
          <Label htmlFor="postType">Тип публикации</Label>

          <Select
            id="postType"
            onChange={this.handleTypeChange}
            value={this.props.type}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changeType',
            })}
          >
            <option value="short">Короткая новость</option>
            <option value="longread">Лонгрид</option>
            <option value="iStory">iStory</option>
          </Select>

          {this.props.type === 'longread' && (
            <React.Fragment>
              <Label htmlFor="author" style={{ marginTop: '24px' }}>Автор</Label>

              <Input
                id="author"
                type="text"
                onChange={this.handleAuthorChange}
                value={this.props.author}
                required
                disabled={!this.props.can({
                  resource: 'publication',
                  permission: 'changeAuthor',
                })}
                placeholder="ФИО"
              />
            </React.Fragment>
          )}

          <Label style={{ marginTop: '24px' }} htmlFor="author">Ссылка на источник</Label>

          <Input
            id="sourceLink"
            type="text"
            onChange={this.handleSourceLinkChange}
            value={this.props.sourceLink}
            placeholder="https://"
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changeSource',
            })}
          />

          <Label style={{ marginTop: '24px' }}>Снузы</Label>

          <SnoozesAutocomplete
            onChange={this.handleSnoozesChange}
            snoozes={this.props.snoozes}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'selectSnoozes',
            })}
          />

          <Label style={{ marginTop: '24px' }} htmlFor="positiveReaction">Положительная реакция</Label>

          <ReactionSelect
            onChange={this.handlePositiveReactionChange}
            value={this.props.positiveReaction}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changePositiveReaction',
            })}
            isPositive
            id="positiveReaction"
          />

          <Label style={{ marginTop: '24px' }} htmlFor="negativeReaction">Отрицательная реакция</Label>

          <ReactionSelect
            onChange={this.handleNegativeReactionChange}
            value={this.props.negativeReaction}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changeNegativeReaction',
            })}
            id="negativeReaction"
          />

          <Label style={{ marginTop: '24px' }} htmlFor="emotion">Градиент</Label>

          <Gradient
            id="emotion"
            value={this.props.emotion}
            onChange={this.props.onEmotionChange}
            min={0}
            max={4}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changeEmotion',
              state: this.props.state,
            })}
          />

          <Mascot
            active={this.props.isMascotActive}
            onMascotActivate={this.handleMascotActivate}
            onMascotDeactivate={this.handleMascotDeactivate}
            mascotPhrase={this.props.mascotPhrase}
            mascotType={this.props.mascotType}
            onPhraseChange={this.handleMascotPhraseChange}
            onTypeChange={this.handleMascotTypeChange}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changeMascot',
            })}
          />

          <Label style={{ marginTop: '24px' }} htmlFor="publishedAt">Дата публикации</Label>

          <Input
            id="publishedAt"
            type="datetime-local"
            style={this.props.publishedAt ? { color: '#fff' } : undefined}
            onChange={this.handleDateChange}
            value={this.props.publishedAt}
            disabled={!this.props.can({
              resource: 'publication',
              permission: 'changePublishedAt',
            })}
          />

          <Label style={{ marginTop: '24px' }} htmlFor="publishedAt">Отправить публикацию</Label>

          <div style={{ marginTop: '12px' }}>
            {TABS.map(tab => (
              <Tab
                id={tab.value}
                active={this.props.destination === tab.value}
                key={tab.value}
                onClick={this.props.onTabClick}
                disabled={!this.props.can({
                  resource: 'publication',
                  permission: 'changeDestination',
                })}
              >
                {tab.label}
              </Tab>
            ))}
          </div>

          <div style={{ margin: '24px 0' }}>
            {CHECKBOX_PARAMS.map((param) => {
              // TODO: Придумать логику для отображения нужных чекбоксов
              if (param.value === 'isAuthorizedOnly' && this.props.type !== 'longread') return null;

              if (!this.props.profile.roles.includes(EDITOR)
                && !this.props.profile.roles.includes(SUPERVISOR)
                && param.value === 'isPinned'
              ) return null;

              if (param.value === 'isPush' && this.props.type === 'iStory') return null;


              return (
                <Checkbox
                  key={param.value}
                  id={param.value}
                  onChange={this.props.onCheckboxChange}
                  checked={this.props[param.value]}
                  toggle
                  disabled={!this.props.can({
                    resource: 'publication',
                    permission: 'changeCheckbox',
                    checkbox: param.value,
                  }) || (param.value === 'isAdult'
                    && this.props.destination === 'application')
                  }
                >
                  {param.label}
                </Checkbox>
              );
            })}
          </div>

          {this.props.match.params.publicationId && (
            <React.Fragment>
              {this.props.can({
                resource: 'publication',
                permission: 'publish',
                state: this.props.state,
              }) && (
                <PrimaryButton
                  type="button"
                  style={{ padding: '13px', marginBottom: '16px' }}
                  onClick={this.handlePublishClick}
                >
                  Опубликовать
                </PrimaryButton>
              )}

              {this.props.can({
                resource: 'publication',
                permission: 'sendToApprove',
                state: this.props.state,
              }) && (
                <PrimaryButton
                  type="button"
                  style={{ padding: '13px', marginBottom: '16px' }}
                  onClick={this.handleProcessClick}
                >
                  Отправить на одобрение
                </PrimaryButton>
              )}

              {this.props.can({
                resource: 'publication',
                permission: 'editorApprove',
                state: this.props.state,
              }) && !this.props.isEditorApproved && (
                <PrimaryButton
                  type="button"
                  style={{ padding: '13px', marginBottom: '16px' }}
                  onClick={this.props.onEditorStateChange}
                >
                  Одобрение редактора
                </PrimaryButton>
              )}

              {this.props.can({
                resource: 'publication',
                permission: 'correctorApprove',
                state: this.props.state,
              }) && !this.props.isCorrectorApproved && (
                <PrimaryButton
                  type="button"
                  style={{ padding: '13px', marginBottom: '16px' }}
                  onClick={this.props.onCorrectorStateChange}
                >
                  Одобрение корректора
                </PrimaryButton>
              )}

              {this.props.can({
                resource: 'publication',
                permission: 'hide',
                state: this.props.state,
              }) && (
                <PrimaryButton
                  type="button"
                  style={{ padding: '13px', marginBottom: '16px' }}
                  onClick={this.handleHideClick}
                >
                  Снять с публикации
                </PrimaryButton>
              )}

              {this.props.can({
                resource: 'publication',
                permission: 'delete',
                state: this.props.state,
              }) && (<DeletePublication onDelete={this.props.onDelete} />)}
            </React.Fragment>
          )}
        </RightColumnBody>
      </Scrollbars>
    );
  }
}

PublicationParams.propTypes = {
  type: PropTypes.oneOf(['short', 'iStory', 'longread']),
  author: PropTypes.string,
  sourceLink: PropTypes.string,
  negativeReaction: PropTypes.string,
  positiveReaction: PropTypes.string,
  destination: PropTypes.oneOf(['everywhere', 'application', 'web']),
  onInputChange: PropTypes.func,
  onFieldChange: PropTypes.func,
  publishedAt: PropTypes.string,
  onTabClick: PropTypes.func,
  onCheckboxChange: PropTypes.func,
  /* eslint-disable react/no-unused-prop-types */
  isPinned: PropTypes.bool,
  isPush: PropTypes.bool,
  isAdult: PropTypes.bool,
  isAuthorizedOnly: PropTypes.bool,
  isNoise: PropTypes.bool,
  isPartner: PropTypes.bool,
  /* eslint-enable react/no-unused-prop-types */
  mascotType: PropTypes.oneOf(['positive', 'negative']),
  mascotPhrase: PropTypes.string,
  isMascotActive: PropTypes.bool,
  emotion: PropTypes.number,
  onEmotionChange: PropTypes.func,
  snoozes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  state: PropTypes.oneOf(['draft', 'processing', 'published', 'hidden']),
  onStateChange: PropTypes.func,
  onEditorStateChange: PropTypes.func,
  onCorrectorStateChange: PropTypes.func,
  isEditorApproved: PropTypes.bool,
  isCorrectorApproved: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      publicationId: PropTypes.string,
    }),
  }),
  profile: PropTypes.shape({
    roles: PropTypes.arrayOf(PropTypes.oneOf([MODERATOR, JORNALIST, BILLER, EDITOR, CORRECTOR, SUPERVISOR])),
  }),
  can: PropTypes.func,
  onDelete: PropTypes.func,
};

PublicationParams.defaultProps = {
  type: 'short',
  author: '',
  sourceLink: '',
  negativeReaction: '',
  positiveReaction: '',
  destination: 'everywhere',
  onInputChange: () => {},
  onFieldChange: () => {},
  onTabClick: () => {},
  publishedAt: undefined,
  onCheckboxChange: () => {},
  isPinned: false,
  isPush: false,
  isAdult: false,
  isAuthorizedOnly: false,
  isNoise: false,
  isPartner: false,
  match: { params: {} },
  mascotType: 'positive',
  mascotPhrase: '',
  isMascotActive: false,
  emotion: 2,
  onEmotionChange: () => {},
  snoozes: [],
  state: 'draft',
  onStateChange: () => {},
  onEditorStateChange: () => {},
  onCorrectorStateChange: () => {},
  isEditorApproved: false,
  isCorrectorApproved: false,
  can: () => {},
  profile: { roles: [] },
  onDelete: () => {},
};

export default withRouter(withProfile(PublicationParams));
